import PropTypes from "prop-types";
import React, { useState } from "react";
import analytics from "web/script/analytics/analytics";
import facebookEvents from "web/script/analytics/facebook-events";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import requester from "web/script/modules/requester";
import url from "web/script/utils/url";
import EmailCaptureForm from "../email-capture-form/email-capture-form";
import styles from "./email-capture-pdp.css";


function EmailCapturePDP({
    cookiePolicyLink,
    privacyPolicyLink,
    termsAndConditionsLink,
    productId,
    shortEUPolicy,
}) {
    const [emailAddress, setEmailAddress] = useState("");
    const [formErrors, setFormErrors] = useState(undefined);
    const [marketingEmails, setMarketingEmails] = useState(false);
    const [privacyPolicy, setPrivacyPolicy] = useState(false);

    function changeEmail(event) {
        setEmailAddress(event.target.value);
    }

    function handleLegalChange(privacyPolicyChecked, marketingEmailsChecked) {
        if (privacyPolicy !== privacyPolicyChecked || marketingEmails !== marketingEmailsChecked) {
            setPrivacyPolicy(privacyPolicyChecked);
            setMarketingEmails(marketingEmailsChecked);
        }
    }

    async function onSubmit(event) {
        event.preventDefault();
        const country = environment.get("country");
        analytics.event("signup_recent_fb", "click_signup_button", "signup_button");
        const body = {
            product_id: productId,
            country,
            reason: "save_for_later_fb_carousel",
            email: emailAddress,
            marketing_emails: marketingEmails,
            privacy_policy: privacyPolicy,
        };

        const parsedURL = url.parse(window.location);
        const nextParam = parsedURL.path;

        let jsonData = undefined;
        const queryParams = url
            .toQueryString({
                type: "back_in_stock",
                product_id: productId,
                email_capture: "true",
                next: nextParam,
            })
            .toString();
        try {
            jsonData = await requester.post(`/account/register/?${queryParams}`, body);
        } catch (e) {
            console.error(e);
            setFormErrors({ other: [gettext("account.login.with_magic_link.error_title")] });
            return;
        }
        if (jsonData && jsonData.success) {
            analytics.tagEvent(
                analytics.TAG_NETWORKS.FACEBOOK,
                facebookEvents.REGISTRATION_COMPLETE
            );

            window.location = jsonData.next;
        } else {
            const { errors } = jsonData.data;
            setFormErrors(errors);
        }
    }

    return (
        <div id="email-capture-pdp">
            <EmailCaptureForm
                className={styles.emailCapturePdpForm}
                captureType={"signup_fb_pdp"}
                cookiePolicyLink={cookiePolicyLink}
                emailAddress={emailAddress}
                emailLabelText={gettext(
                    "account.register.return_lead.recently_viewed_items.email_label",
                )}
                formErrors={formErrors}
                onEmailChange={changeEmail}
                onLegalChange={handleLegalChange}
                onSubmit={onSubmit}
                privacyPolicyLink={privacyPolicyLink}
                submitText={gettext("save_for_later.cta.variant_b")}
                submitClass={styles.submitButton}
                termsAndConditionsLink={termsAndConditionsLink}
                shortEUPolicy={shortEUPolicy}
                isFBPDP={true}
            />
        </div>
    );
}

export default EmailCapturePDP;

EmailCapturePDP.propTypes = {
    cookiePolicyLink: PropTypes.string.isRequired,
    privacyPolicyLink: PropTypes.string.isRequired,
    termsAndConditionsLink: PropTypes.string.isRequired,
    shortEUPolicy: PropTypes.bool,
    productId: PropTypes.string,
};
